<template>
	<div>
		<StripeElements
			ref="elementsRef"
			:pk="api_key"
			:amount="amount"
			locale="en"
			@token="tokenCreated"
			@loading="_loading = $event"
		>
		</StripeElements>

		<button class="btn btn-primary f-r" @click="submit" :disabled="loading">
			Next
			<div class="lds-ring" v-show="loading">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</button>
	</div>
</template>

<script>
import { StripeElementCard } from 'vue-stripe-checkout';

export default {
	props: {
		amount: {
			type: Number,
			default: 1000,
		},
	},
	components: {
		StripeElements: StripeElementCard,
	},
	computed: {
		...mapGetters(['api_key', 'loading']),
	},
	data: () => ({
		_loading: false,
		token: null,
		charge: null,
	}),
	methods: {
		submit() {
			this.$store.commit('loading', true);
			this.$refs.elementsRef.submit();
		},
		tokenCreated(token) {
			this.token = token;
			// for additional charge objects go to https://stripe.com/docs/api/charges/object
			this.charge = {
				source: token.id,
				amount: this.amount, // the amount you want to charge the customer in cents. $100 is 1000 (it is strongly recommended you use a product id and quantity and get calculate this on the backend to avoid people manipulating the cost)
				description: this.description, // optional description that will show up on stripe when looking at payments
			};

			this.sendTokenToServer(this.charge);
		},
		sendTokenToServer(charge) {
			// Send to charge to your backend server to be processed
			// Documentation here: https://stripe.com/docs/api/charges/create
			this.$emit('payment-complete', { token: this.token, charge });
		},
	},
	mounted() {},
};
</script>
